export default "__VITE_ASSET__DzwmU_b7__"